module.exports = __webpack_public_path__ + "img/down.7f1dfaa7.svg";